<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">I would like to thank Austin Macauley publishers for the opportunity to release this book.</p><br/>
<p style="text-indent:0em;">I would like to thank my husband for his constant support, understanding and encouragement and for providing an insight through his eyes. I would also like to thank my children for being there to hold my hand when needed.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?2545290c